2<template>
  <div>
    <abstractTable
      :columns="followUpColumns"
      :data="followUps"
      :classes="'ui very compact left aligned celled table'"
      :dataPerPage="15"
      :paginationEnable="true"
      :paginationNextButtonText="$t('next')"
      :paginationPervButtonText="$t('previous')"
      :paginationFirstPageButtonText="$t('first')"
      :paginationLastPageButtonText="$t('last')"
      v-if="followUps.length"
    />

    <div v-else>
      <div class="ui placeholder segment" style="margin-bottom: 50px">
        <div class="ui icon header" style="color: #092442">
          <i class="dont icon"></i>
          No follow ups has been added yet
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default
  },
  props: {
    followUps: { type: Array, default: () => [] }
  },
  computed: {
    followUpColumns () {
      return [
        { header: 'Week', fieldName: 'name', show: true, width: '20%' },
        { header: 'Follow Up', fieldName: 'result', show: true }
      ]
    }
  },
  methods: {
    timeFormat (time) {
      return window.moment(time).format('LLLL')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/patients/patient_log_componenets/medical_history_components/FollowUps.vue